import { School } from "app/shared/model";

export function toSchoolScopeId(raw: unknown): string | undefined {
    if (raw == null) return undefined;
    const str = String(raw);

    if (/^School-(-?\d+)$/.test(str)) return str;

    if (/^-?\d+$/.test(str)) return `School-${str}`;

    return undefined;
}

export function toSchoolNumericId(raw: unknown): string | undefined {
    if (raw == null) return undefined;
    const str = String(raw);

    const m = /^School-(-?\d+)$/.exec(str);
    if (m) return m[1];

    if (/^-?\d+$/.test(str)) return str;

    return undefined;
}

export function getSchoolKey(school: School): string {
    return (
        toSchoolScopeId((school as any).id ?? (school as any).schoolId) ??
        String((school as any).id ?? (school as any).schoolId ?? school.code)
    );
}

export function toSchoolScopeIdFromSchool(school: School): string | undefined {
    return toSchoolScopeId((school as any).id);
}

export function toSchoolNumericIdFromSchool(school: School): string | undefined {
    return toSchoolNumericId((school as any).id);
}
